import { TranslationObject } from '@ngx-translate/core';

const ru: TranslationObject = {
  ru: 'Русский',
  app: {
    test: 'Это тестовая метка',
    title: 'SWD - Рабочая Дисциплина',
    welcomeMessage: 'Добро пожаловать в веб-приложение SWD',
    forms: {
      ok: 'Ok',
      cancel: 'Отменить',
      continue: 'Продолжить',
      labels: {
        businessUnit: 'Бизнес подразделение',
        placeholderBusinessUnit: 'Выберите бизнес-единицу',
        user: 'Пользователь',
        name: 'Имя',
        description: 'Описание',
        placeHolderDescription: 'Введите описание',
        placeHolderReviewType: 'Выберите тип проверки',
        mandatory: 'Обязательный',
      },
      create: 'Создать',
      unsavedChangesWarning:
        'Обнаружены несохраненные изменения. Если вы покинете эту страницу, внесенные вами изменения будут потеряны.<br>Вы хотите продолжить?',
    },
    warnings: {
      removeOwnAdminRights:
        'Вы удалили свои права администратора. Пожалуйста, обновите веб-страницу, чтобы избежать неисправностей.',

      removeOwnAccess: 'Вы удалили свой доступ. Пожалуйста, обновите веб-страницу, чтобы избежать неисправностей.',
    },
  },
  navigation: {
    startWorkDone: 'Наблюдения',
    category: 'Категории',
    businessUnits: 'Бизнес-подразделения',
    sysAdmins: 'Системные Администраторы',
    administration: 'Управление',
    users: 'Пользователи',
    areas: 'Зоны',
    errorReductionTools: 'Инструменты снижения ошибок',
    nonBadgedPersons: 'Наблюдаемые лица без пропуска',
  },
  startWorkDoneList: {
    title: 'Наблюдения',
    noStartWorkDone:
      'Выберите Бизнес-подразделение, Зону, Подзону, Категорию и Наблюдаемое лицо для отображения записей',
    emptyList: 'Записи рабочей дисциплины для выбранных фильтров не найдены',
    id: 'ID',
    responseTitle: 'Заголовок',
    question: 'Контроль',
    answer: 'Ответ',
    score: 'Балл',
    comment: 'Комментарий',
    errorReductionTool: 'Инструмент снижения ошибок',
    updatedBy: 'Обновлено',
    updatedDate: 'Дата обновления',
    createNewStartWorkDone: 'создать новую начатую работу',
    reviewType: 'Тип обзора',
    area: 'Зона',
    observationDate: 'Дата наблюдения',
    subArea: 'Подзона',
    category: 'Категория',
    placeholderArea: 'Выберите зону',
    placeholderSubArea: 'Выберите подзону',
    placeholderCategory: 'Выберите категорию',
    addQuestion: 'Добавить Контроль',
    description: 'Описание',
    subSection: 'Подраздел',
    clearAnswer: 'Очистить Ответ',
    deleteQuestion: 'Удалить Контроль',
    deleteQuestionTitle: 'Удалить Контроль',
    confirmDeleteQuestion:
      '<span>Вы уверены, что хотите удалить этот контроль?</span><br><br><span><b>Контроль:</b> {{ description }}</span>',
    editQuestion: 'Редактировать Контроль',
    editQuestionHeader: 'Редактировать Контроль',
    userSearch: 'Наблюдаемое лицо',
    userSearchPlaceholder: 'Поиск по имени или email...',
    supervisor: 'Руководитель',
    noSupervisor: 'Руководитель не найден',
    nonBadgedPersonObserved: 'Наблюдаемое лицо без пропуска',
    placeholderNonBadgedPersonObserved: 'Выберите лицо без пропуска',
    personSelectionConflict:
      'Можно заполнить только одно из следующих полей: Наблюдаемое лицо или Наблюдаемое лицо без пропуска.',
    generateReport: 'Создать Отчет',
    completeReview: 'Завершить и Отправить Отчет',
    generateReportInfoMessage:
      'Ваш отчёт формируется и будет загружен автоматически. Это может занять несколько секунд.',
    generateSuccessMessage: 'Отчет успешно создан',
    reviewSuccessMessage: 'Отчет SWD об наблюдениях успешно отправлен',
    sendEmail: 'Отправить Email',
    emailSuccessMessage: 'Email успешно отправлен',
    emailErrorMessage: 'Ошибка при отправке email',
    tableColumns: {
      businessUnit: 'Бизнес-подразделение',
      category: 'Категория',
      subArea: 'Подзона',
      area: 'Зона',
      user: 'Наблюдаемое лицо',
      nonBadgedPerson: 'Наблюдаемое лицо без пропуска',
      supervisor: 'Надзорчик',
      observationDate: 'Дата наблюдения',
      totalScore: 'Общий балл',
      createdBy: 'Наблюдатель',
    },
    viewEdit: 'Просмотр / Редактировать',
  },
  startWorkDoneDetail: {
    title: 'Наблюдение',
    details: 'Общая информация',
    notFound: 'Запись рабочей дисциплины не найдена',
    accessDenied: 'У вас нет доступа к этому наблюдению.',
    saveSuccess: 'Запись успешно обновлена',
    editInfo: 'Редактировать информацию',
    saveInfo: 'Сохранить информацию',
    errorReductionTools: 'Инструменты снижения ошибок',
    noControls: 'Элементы управления не найдены. Сначала добавьте элементы управления в эту категорию.',
    totalScore: 'Общий балл',
    deleteObservation: 'Удалить наблюдение',
    deleteConfirmTitle: 'Удалить наблюдение',
    deleteConfirmMessage: 'Вы уверены, что хотите удалить это наблюдение? Это действие нельзя отменить.',
    deleteSuccess: 'Наблюдение успешно удалено',
    noObservationDate: 'Дата наблюдения не выбрана. Пожалуйста, выберите дату перед завершением этой проверки.',
  },
  categoryList: {
    title: 'Категории',
  },
  admin: {
    sysAdminList: {
      title: 'Системные Администраторы',
      addSysAdmin: 'добавить системного администратора',
      fullName: 'полное имя',
      email: 'электронная почта',
      dialogs: {
        removeAccessHeader: 'Подтверждение',
        removeAccessMessage:
          'Вы уверены, что хотите удалить доступ системного администратора для: [{{firstName}} {{lastName}}]?',
      },
    },
    businessUnitLists: {
      title: 'Бизнес-подразделения',
      addBusinessUnit: 'добавить бизнес-единицу',
      tableTitle: 'Бизнес подразделение',
      noBusinessUnits: 'Бизнес-подразделения не найдены.',
      dialogs: {
        createHeader: 'Создать бизнес-подразделение',
        namePlaceholder: 'Введите название',
      },
    },
    businessUnitEdit: {
      title: 'Редактировать бизнес-единицу',
    },
    errorReductionTools: {
      title: 'Инструменты снижения ошибок',
      addErt: 'добавить инструмент снижения ошибок',
      tableTitle: 'инструмент снижения ошибок',
      noErts: 'Инструменты снижения ошибок не найдены.',
      dialogs: {
        createHeader: 'Создать инструмент снижения ошибок',
        editHeader: 'Редактировать инструмент снижения ошибок',
        namePlaceholder: 'Введите название',
        deleteTitle: 'Удалить инструмент снижения ошибок',
        deleteMessage: 'Вы уверены, что хотите удалить инструмент снижения ошибок <strong>{{name}}</strong>?',
        deleteSuccess: 'Инструмент снижения ошибок успешно удалён.',
        deleteConflict:
          'Этот инструмент снижения ошибок нельзя удалить, так как он привязан к одному или нескольким элементам управления.',
      },
    },
    nonBadgedPersons: {
      title: 'Наблюдаемые лица без пропуска',
      addPerson: 'добавить наблюдаемое лицо без пропуска',
      importPeople: 'импортировать пользователей разрешений без пропуска',
      noPeople: 'Лица без пропуска не найдены.',
      columns: {
        name: 'наблюдаемое лицо без пропуска',
        supervisorEmail: 'email руководителя',
        supervisorName: 'имя руководителя',
      },
      dialogs: {
        createHeader: 'Добавить наблюдаемое лицо без пропуска',
        editHeader: 'Редактировать наблюдаемое лицо без пропуска',
        nameLabel: 'Лицо без пропуска',
        nameRequired: 'Имя обязательно',
        supervisorLabel: 'Руководитель',
        supervisorPlaceholder: 'Поиск по имени или email...',
        supervisorRequired: 'Email обязателен',
        deleteTitle: 'Удалить лицо без пропуска',
        deleteMessage: 'Вы уверены, что хотите удалить лицо без пропуска <strong>{{name}}</strong>?',
        deleteSuccess: 'Лицо без пропуска успешно удалено.',
        deleteConflict:
          'Это лицо без пропуска нельзя удалить, так как оно участвовало в одном или нескольких наблюдениях.',
        importHeader: 'Импорт наблюдаемых лиц без пропуска',
        attachDocument: 'Прикрепить документ',
        uploadedOn: 'Загружено {{date}}',
        removeFile: 'Удалить файл',
        invalidFile: 'Выберите один файл Excel (.xlsx) размером не более 5 МБ.',
        importFailed: 'Ничего не импортировано. Исправьте эти ошибки и повторите попытку:',
        importSuccess: 'Импорт завершён. Импортировано: {{imported}}. Пропущено дубликатов: {{skipped}}.',
      },
    },
    areas: {
      title: 'Зоны',
      areasTitle: 'Зоны',
      subAreasTitle: 'Подзоны',
      addArea: 'Добавить зону',
      addSubArea: 'Добавить подзону',
      areaName: 'Название',
      subAreaName: 'Подзоны',
      category: 'Категория',
      noAreas: 'Нет доступных зон.',
      noSubAreas: 'Нет доступных подзон.',
      selectAreaMessage: 'Выберите зону, чтобы управлять её подзонами.',
      dialogs: {
        createAreaHeader: 'Создать зону',
        editAreaHeader: 'Редактировать зону',
        createSubAreaHeader: 'Создать подзону',
        editSubAreaHeader: 'Редактировать подзону',
        namePlaceholder: 'Введите название',
        category: 'Категория',
        categoryPlaceholder: 'Выберите категорию (необязательно)',
        deleteAreaTitle: 'Удалить зону',
        deleteAreaMessage: 'Вы уверены, что хотите удалить зону <strong>{{name}}</strong>?',
        deleteAreaLinkedRecords: 'Невозможно удалить эту зону, так как с ней связаны записи рабочей дисциплины.',
        deleteSubAreaTitle: 'Удалить подзону',
        deleteSubAreaMessage: 'Вы уверены, что хотите удалить подзону <strong>{{name}}</strong>?',
        deleteSubAreaLinkedRecords: 'Невозможно удалить эту подзону, так как с ней связаны записи рабочей дисциплины.',
      },
    },
  },
  user: {
    requestAccess: {
      title: 'Не зарегистрирован',
      forms: {
        submit: 'Запрос доступа',
      },
      dialogTitle: 'Запрос доступа',
      dialogSubtitle: 'Вы собираетесь запросить доступ к <strong>{{name}}</strong>, Вы хотите продолжить?',
      reloadWarning:
        'Если вы открыли эту страницу, но уже имеете доступ, пожалуйста, нажмите на следующую ссылку, чтобы перезагрузить. В противном случае свяжитесь со службой поддержки.',
      reload: 'Перезагрузить',
    },
    pendingAccess: {
      title: 'Здравствуйте, ваш запрос на доступ находится в обработке',
      reloadWarning:
        'Если вы открыли эту страницу, но уже имеете доступ, пожалуйста, нажмите на следующую ссылку, чтобы перезагрузить. В противном случае свяжитесь со службой поддержки.',
      reload: 'Перезагрузить',
    },
  },
  header: {
    logoAlt: 'Логотип CVX',
    userAvatarAlt: 'Аватар пользователя',
    unknownUser: 'Неизвестно',
  },
  footer: {
    text: 'Chevron Corporation. Все права защищены.',
    version: 'SWD v{{ version }}',
  },
  category: {
    title: 'Категории',
    create: 'Создавать',
    name: 'Имя',
    description: 'Описание',
    actions: 'Действия',
    edit: 'Изменить',
    manage: 'Управление',
    delete: 'Удалить',
    confirmDelete:
      '<span>Вы уверены, что хотите удалить эту категорию?</span><br><br><span>Имя: {{ name }}<br>Описание: {{ description }}</span>',
    noCategories: 'Нет доступных категорий.',
    titleCreate: 'Создать категорию',
    createNew: 'Создать новый',
    selectPlaceholder: 'Выберите один вариант...',
    titleEdit: 'Редактировать категорию',
    titleDelete: 'Удалить категорию',
    deletedSuccessfully: 'Категория успешно удалена',
    importCategory: 'Импорт категории',
    importCategoryTitle: 'Импорт категории в ',
    selectCategoryType: 'Выберите тип категории',
    confirm: 'Подтвердить',
    importSuccessMessage: 'Категория успешно импортирована',
    manageControls: 'Управление контролями',
    noControls: 'Нет доступных контролей.',
    selectBusinessUnit: 'Выберите бизнес-единицу для отображения контролей',
    importCategoriesTitle: 'Импорт категорий',
    import: 'Импорт',
  },
  common: {
    selectAnswer: 'Select answer',
    noAttempt: 'No Attempt',
    needsImprovement: 'Needs Improvement',
    meetsExpectations: 'Meets Expectations',
    exceedsExpectations: 'Exceed Expectations',
    save: 'Сохранить',
    businessUnit: 'Подразделение',
    forbidActionErrorMessage: 'Пользователь не имеет права выполнять это действие.',
    name: 'Имя',
    code: 'Код',
    cancel: 'Отмена',
    genericErrorMessage: 'Произошла непредвиденная ошибка. Пожалуйста, попробуйте позже.',
    savedSuccessfully: 'Успешно сохранено',
    delete: 'удалить',
    deletedSuccessfully: 'Успешно удалено',
    edit: 'Редактировать',
    leaveWithOutSaving: 'Выйти без сохранения',
    language: 'Язык',
    view: 'Просмотр',
    back: 'Назад',
    createdBy: 'Создано',
    updatedBy: 'Обновлено',
    updatedDate: 'Дата обновления',
    errors: {
      failedToSubmit: 'Не удалось отправить ответ. Пожалуйста, попробуйте ещё раз.',
    },
  },
  serverError: {
    title: 'Сервер недоступен',
    message: 'Не удаётся подключиться к серверу. Проверьте сетевое подключение или повторите попытку позже.',
    returnHome: 'Вернуться на главную',
  },
  pageNotFound: {
    title: 'Страница не найдена',
    message: 'Запрашиваемая страница не существует.',
    returnHome: 'Вернуться на главную',
  },
  unauthorized: {
    title: 'Доступ запрещён',
    message: 'У вас нет разрешения на доступ к этой странице.',
    returnHome: 'Вернуться на главную',
  },
  categoryManage: {
    title: 'Управление содержимым [{{ description }}]',
    questionsTitle: 'Контроли',
    addQuestionAction: 'добавить контроль',
    questionName: 'Контроль',
    questionNamePlaceholder: 'Введите текст контроля',
    errorReductionTools: 'Инструменты снижения ошибок',
    ertPlaceholder: 'Выберите инструменты снижения ошибок',
    noQuestions: 'Контроли не найдены. Добавьте контроль, чтобы начать.',
    sectionsTitle: 'Разделы',
    subSectionsTitle: 'Подразделы',
    mandatoryLabel: 'Обязательный',
    createNewSubsectionAction: 'добавить группу контролей',
    addSectionAction: 'добавить раздел',
    emptySubSectionsMessage: `<p>Для этого раздела нет доступного содержимого.</p>
      <p>Пожалуйста, добавьте подраздел, чтобы начать.</p>`,
    itemDescriptionTableHeader: 'Описание',
    createNewItemAction: 'Добавить контроль',
    createSectionHeader: 'Создать новый раздел',
    editSectionHeader: 'Редактировать раздел',
    confirmDeleteSection: 'Вы уверены, что хотите удалить раздел <strong>{{description}}</strong>?',
    createSubSectionHeader: 'Добавить группу контролей',
    editSubSectionHeader: 'Редактировать подраздел',
    createQuestionTitle: 'Создать контроль',
    ShouldAddCommentToQuestion:
      'Пользователь должен добавить комментарий к любому контролю, на который дан ответ "Н/Д"',
    deleteQuestionTitle: 'Удалить контроль',
    confirmDeleteQuestion:
      '<span>Вы уверены, что хотите удалить этот контроль?</span><br><br><span><b>Описание:</b> {{ description }}</span>',
    confirmDeleteSubSection: 'Вы уверены, что хотите удалить подраздел <strong>{{description}}</strong>?',
    deleteSectionHeader: 'Удалить раздел',
    deleteSubSectionHeader: 'Удалить подраздел',
    editQuestionTitle: 'Редактировать контроль',
    defaultSubSectionName: 'Контроли',
  },
  paginator: {
    previous: 'Предыдущий',
    next: 'Следующий',
    currentPageReport: '{{currentInitialRow}} - {{currentLastRow}} из {{totalRecords}}',
  },
  usersList: {
    title: 'Пользователи',
    forms: {
      displayInactiveUsers: 'показать неактивных пользователей',
    },
    actions: {
      addNewUser: 'Добавить нового пользователя',
      grantAccess: 'предоставить доступ',
    },
    table: {
      fullName: 'полное имя',
      email: 'электронная почта',
      admin: 'администратор',
    },
    noUsers: 'Нет доступных пользователей',

    dialogs: {
      removeAccessHeader: 'Подтверждение',
      removeAccessMessage: 'Вы уверены, что хотите удалить доступ для: [{{fullName}}]?',
    },
  },
  actionItems: {
    title: 'Пункты действия',
    addActionItem: 'добавить пункт действия',
    actionTitle: 'Заголовок',
    assignee: 'Исполнитель',
    date: 'Дата',
    id: '№',
    comment: 'Комментарий',
    priority: 'Приоритет',
    dialogs: {
      configureActionItem: 'Составить пункт действия',
      configureComment: 'Комментарий',
      deleteActionItemHeader: 'Удалить ПД',
      deleteActionItemMessage: 'Вы уверены, что хотите выполнить это действие?',
    },
  },
  comments: {
    title: 'Комментарии',
    addComment: 'добавить комментарий',
    noComments: 'Нет комментариев',
    dialogs: {
      configureComment: 'Комментарий',
      deleteCommentHeader: 'Удалить комментарий',
      deleteCommentMessage: 'Вы уверены, что хотите выполнить это действие?',
    },
    comment: 'Комментарий',
    instructions: {
      title: 'Комментарии должны включать:',
      observed: 'Что было замечено',
      coaching: 'Какое коучинг было предоставлено',
      action: 'Какие действия были предприняты для решения проблем',
      feedback: 'Какой позитивный отзыв был дан за превышение ожиданий',
    },
  },
  features: {
    startWorkDone: {
      labels: {
        observationComment: 'Комментарий к наблюдению',
      },
      placeholders: {
        enterComment: 'Введите свой коучинговый отзыв или контекст для этого ответа...',
      },
      messages: {
        responseSubmitted: 'Ответ успешно отправлен',
        commentRequired: 'Комментарий требуется для этого типа ответа',
      },
      responseAnswers: {
        noAttempt: 'Нет попыток',
        needsImprovement: 'Требует улучшения',
        meetsExpectations: 'Соответствует ожиданиям',
        exceedsExpectations: 'Превышает ожидания',
        notApplicable: 'Не применяется',
      },
    },
  },
};
export default ru;
